module.exports = __webpack_public_path__ + "static/rig-144809c0f1e3de2083993290c00c0d64.jpg";